export const WHITE_HEX = '#ffffff';
export const DISABLED_GREY_HEX = '#DDE2E6';

export enum ChangeFields {
    Form = 'TITLE',
    Line = 'LINE',
    Details = 'DETAILS',
    Field = 'FIELD',
    PrevValue = 'OLDVALUE',
    CurrValue = 'NEWVALUE',
    Signature = 'USERLOGIN',
    Contact = 'PHONENAME',
    Date = 'UDATE'
}

export const changeLogDefaultFields = [
    'TITLE',
    'DETAILS',
    'FIELD',
    'OLDVALUE',
    'NEWVALUE',
    'USERLOGIN',
    'UDATE'
];

export const statusLogDefaultFields = [
    'UDATE',
    'STATDES',
    'OWNERLOGIN',
    'INITIATORLOGIN',
    'USERLOGIN'
];
